const StartModal = ({ setReady }) => {
  return (
    <div className="modal-start">
      <p className="modal-start__text">
        Dear wanderer, <br /> on “Crystal Map” you can explore different layers
        of reality but the only way to do it is with the movement of your body.
        Please enable gps for the full experience and start to walk in your
        surroundings.
      </p>
      <button className="modal-start__btn" onClick={setReady}>
        Start
      </button>
    </div>
  );
};

export default StartModal;
